<template>
    <div class="hospital-index">
        <swiperBanner :bannerList='bannerList'></swiperBanner>
        <div class="main-content">
            <div class="depart-info clearfix">
                <div class="fl img-left">
                    <img :src="hospitalData.introduction_img" :alt="hospitalData.title" class="img-responsive">
                </div>
                <div class="img-right fl">
                    <div class="title fs24 fwb pt20 mb20">{{hospitalData.title}}</div>
                    <div class="quill-editor">
                        <div class="ql-container ql-snow">
                            <div class="ql-editor content pre-wrap" v-html="hospitalData.introduction"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="main-content">
            <div class="depart-title fs24 color-blank">联系我们</div>
            <div class="main-box clearfix color-blank fs14 mb40">
                <div class="info-left fl pt20">
                    <div class="mb20" v-if="hospitalData.address"><img src="../../assets/images/branch-area.png" alt="" class="mr20 wh20"><span>地址：{{hospitalData.address}}</span></div>
                    <div class="mb20" v-if="hospitalData.tel"><img src="../../assets/images/branch-phone.png" alt="" class="mr20 wh20"><span>电话：{{hospitalData.tel}}</span></div>
                    <div class="mb20" v-if="hospitalData.post_code"><img src="../../assets/images/branch-email.png" alt="" class="mr20 wh20"><span>邮编：{{hospitalData.post_code}}</span></div>
                    <div class="mb20" v-if="hospitalData.fax"><img src="../../assets/images/branch-fax.png" alt="" class="mr20 wh20"><span>传真：{{hospitalData.fax}}</span></div>
                </div> 
                <div class="qr-box right-box fr tc">
                    <div class="fl mr20" v-if="hospitalData.wb_thumb != ''">
                        <img :src="hospitalData.wb_thumb" :alt="hospitalData.title" class="wh80 mb20">
                        <div class="tc">官方微博</div>
                    </div>
                    <div class="fl" v-if="hospitalData.wx_thumb != ''">
                        <img :src="hospitalData.wx_thumb" :alt="hospitalData.title" class="wh80 mb20">
                        <div class="tc">官方微信</div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import swiperBanner from '@/components/swiperBanner'
import seoArgs from '../../utils/setSeoArgs';

export default {
    props: {

    },
    data() {
        return {
            bannerList:[],
            hospitalData:{},
        };
    },
    computed: {

    },
    created() {
        const hospitalSeoInfo = this.$cookies.get(this.api.cachePrex+'1') || {};
        hospitalSeoInfo.name = '医院介绍';
        seoArgs.setSeoArgs(hospitalSeoInfo);

        this.getHospital();
        this.getBanner();
    },
    mounted() {

    },
    watch: {
      $route(to,from){
        this.short_name=to.params.short_name;
        sessionStorage.setItem('english_short_name',this.short_name);
        this.getHospital();
        this.getBanner();
      }
    },
    methods: {
        getHospital(){
            this.$axios.post(this.api.hospital.index,{},res =>{
                this.hospitalData=res.data;
            });
        },
        getBanner(){
            this.$axios.post(this.api.index.index,{},res =>{
                this.bannerList=res.data.banner_list;
            },err =>{

            });
      },
    },
    components: {
        swiperBanner
    },
};
</script>

<style scoped>
.hospital-index{position: relative;top:-100px;}
.depart-info .img-left{width:400px;height:400px;margin-right:40px;}
.depart-info .img-right{width:720px;}
.depart-info .img-right .title{color:rgba(74,144,226,1);line-height:33px;}
.depart-info .img-right .content{line-height:20px;}
.depart-title{padding:40px 0 20px;line-height:33px;}
.main-box{height:180px;line-height:20px;}
.main-box .right-box{line-height:20px;}
.main-box .qr-box .fl{padding-top:30px;width:160px;height:180px;box-shadow:0px 0px 10px 0px rgba(0,0,0,0.1);border-radius:5px;}
.main-box .qr-box p{margin-top:20px;}
</style>



// WEBPACK FOOTER //
// src/view/hospital/index.vue